export const Spinner: React.FC<any> = ({ className }) => {
  return (
    <div
      className={`${className} w-[123px]`}
      dangerouslySetInnerHTML={{
        __html: `
        <svg xmlns="http://www.w3.org/2000/svg" width="123" height="123" viewBox="0 0 123 123" fill="none">
        <path d="M5.11101 60.3375C4.82156 72.087 8.21971 83.632 14.8282 93.3511C21.4367 103.07 30.9236 110.475 41.9565 114.526C52.9893 118.577 65.014 119.07 76.3415 115.936C87.669 112.803 97.7305 106.199 105.113 97.0542C112.495 87.9089 116.827 76.681 117.501 64.9473C118.175 53.2136 115.156 41.5636 108.869 31.6335C102.582 21.7034 93.3426 13.992 82.4482 9.58231C71.5538 5.17267 59.5517 4.28629 48.1277 7.04768" stroke="#854ECA" stroke-width="10" stroke-linecap="round"/>
        </svg>
    `,
      }}
    />
  );
};
